import React from "react";
import "../../css/SecurityAlert.css";

const SecurityAlertContent = ({ headingId, domain = "udhaarportal.com", teamName = "Udhaar Portal" }) => {
  return (
    <div className="security-alert-box" role="document">
      <header className="security-alert-box__header">
        <span className="security-alert-box__icon" aria-hidden="true">⚠️</span>
        <div>
          <p className="security-alert-box__eyebrow">Security Alert / सुरक्षा चेतावनी</p>
          <h2 className="security-alert-box__title" id={headingId}>
            Stay safe from fraudulent payment requests
          </h2>
        </div>
      </header>

      <div className="security-alert-box__content">
        <section className="security-alert-box__section">
          <p className="security-alert-box__copy">
            <strong>English:</strong> Fraudsters are sending fake payment requests via WhatsApp, SMS, and social media,
            impersonating <strong>{domain}</strong> employees. Stay alert.
          </p>
          <p className="security-alert-box__copy">
            <strong>हिंदी:</strong> धोखेबाज़ WhatsApp, SMS और सोशल मीडिया के माध्यम से नकली भुगतान अनुरोध भेज रहे हैं, जो
            <strong> {domain}</strong> के कर्मचारियों के रूप में पहचान बना रहे हैं। सतर्क रहें।
          </p>
        </section>

        <ul className="security-alert-box__list">
          <li>
            <span className="security-alert-box__bullet" aria-hidden="true">✓</span>
            <div>
              <p className="security-alert-box__text">Do not click unknown links or reply to suspicious messages.</p>
              <p className="security-alert-box__text security-alert-box__text--hi">अज्ञात लिंक पर क्लिक न करें या संदिग्ध संदेशों का जवाब न दें।</p>
            </div>
          </li>
          <li>
            <span className="security-alert-box__bullet" aria-hidden="true">✓</span>
            <div>
              <p className="security-alert-box__text">Verify email IDs and domains before engaging.</p>
              <p className="security-alert-box__text security-alert-box__text--hi">संलग्न होने से पहले ईमेल ID और डोमेन सत्यापित करें।</p>
            </div>
          </li>
          <li>
            <span className="security-alert-box__bullet" aria-hidden="true">✓</span>
            <div>
              <p className="security-alert-box__text">Be cautious of calls or messages claiming to be from us.</p>
              <p className="security-alert-box__text security-alert-box__text--hi">हमारे होने का दावा करने वाले कॉल या संदेशों से सावधान रहें।</p>
            </div>
          </li>
        </ul>

        <section className="security-alert-box__panel security-alert-box__panel--warning">
          <p className="security-alert-box__text">
            <strong>English:</strong> <strong>{domain}</strong> is not responsible for losses from payments to unverified persons or links.
          </p>
          <p className="security-alert-box__text security-alert-box__text--hi">
            <strong>हिंदी:</strong> <strong>{domain}</strong> अप्रमाणित व्यक्तियों या लिंक को भुगतान से होने वाले नुकसान के लिए जिम्मेदार नहीं है।
          </p>
        </section>

        <section className="security-alert-box__panel security-alert-box__panel--safe">
          <p className="security-alert-box__text security-alert-box__text--hi">
            <strong>हिंदी:</strong> भुगतान केवल हमारी आधिकारिक वेबसाइट <strong>{domain}</strong> या अधिकृत लिंक से करें।
          </p>
          <p className="security-alert-box__text">
            <strong>English:</strong> Pay only through our official website <strong>{domain}</strong> or authorized link.
          </p>
          <p className="security-alert-box__text security-alert-box__text--hi">
            <strong>हिंदी:</strong> किसी अज्ञात नंबर/लिंक पर भरोसा न करें।
          </p>
          <p className="security-alert-box__text">
            <strong>English:</strong> Do not trust any unknown number/link.
          </p>
        </section>
      </div>

      <footer className="security-alert-box__footer">— Team {teamName}</footer>
    </div>
  );
};

export default SecurityAlertContent;

